import { useContext } from 'react';

import PropTypes from 'prop-types';

import { AuthContext } from '../../../../../actions/auth-context';
import { editionPendencies } from '../../../../../commons/order-checklist';

const FinishEditOrderButton = ({ order }) => {
  const { hasPermissions } = useContext(AuthContext);

  const viewButton =
    order.order_status === 'Em edição' && hasPermissions(['edit_photos']);

  // FEAT-018: checklist de pendências da edição (fonte única em
  // commons/order-checklist, espelhada no backend). O botão fica VISÍVEL porém
  // desabilitado enquanto houver pendências — o editor vê o que falta.
  const pendencies = editionPendencies(order);

  const ready = pendencies.length === 0;

  return (
    <>
      {viewButton && (
        <div className="col-sm col-md-4 col-xl-3 mt-2">
          {!ready && (
            <div
              className="alert alert-warning py-2 px-3 mb-2 text-start"
              style={{ fontSize: '12px', textTransform: 'none' }}
            >
              <b>Pendências para finalizar a edição:</b>
              <ul className="mb-0 ps-3">
                {pendencies.map((pendency) => (
                  <li key={pendency}>{pendency}</li>
                ))}
              </ul>
            </div>
          )}

          <button
            className="btn btn-success btn-block col-12"
            type="button"
            disabled={!ready}
            data-bs-toggle={ready ? 'modal' : undefined}
            data-bs-target={ready ? '#modal-finish-edit-order' : undefined}
          >
            finalizar edição
          </button>
        </div>
      )}
    </>
  );
};

FinishEditOrderButton.propTypes = {
  order: PropTypes.shape({
    id: PropTypes.string,
    order_status: PropTypes.string,
    photos: PropTypes.arrayOf(Object),
    products: PropTypes.arrayOf(Object),
  }).isRequired,
};

export default FinishEditOrderButton;
